module.exports = function() {
  return new Worker(__webpack_public_path__ + "883a9def02b21d938154.worker.js");
};